import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  // Horaires and products moved out of footer

  return (
    <footer id="footer" role="contentinfo">
      {/* Pre-Footer CTA strip */}
      <div className="bg-white text-gray-800 border-y border-gray-100 py-4 shadow-xl border border-gray-200">
        <div className="container mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <p className="text-xs uppercase tracking-wider text-gray-500">Votre projet métal, entre de bonnes mains</p>
            <p className="text-base md:text-lg font-semibold">Qualité • Rapidité • Sur mesure</p>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="bg-gray-950 text-gray-300 pt-10">
        <div className="container mx-auto px-4 py-14">
          <div className="grid gap-12 md:grid-cols-3">
            {/* Brand + mini intro */}
            <div>
              <div className="leading-tight mb-4">
                <div className="text-2xl font-extrabold text-white">Metal JelJeli</div>
                <div className="text-sm text-gray-400">Découpe laser & design métal</div>
              </div>
              <p className="text-sm text-gray-400 max-w-xs">
                Fabrication sur mesure: claustras, portails, rampes, structures métal et plus. Qualité et finitions soignées.
              </p>
              <div className="flex gap-3 mt-6">
                <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 hover:border-white/20 hover:bg-white/5 transition-colors" aria-label="Facebook">
                  <FaFacebook />
                </button>
                <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 hover:border-white/20 hover:bg-white/5 transition-colors" aria-label="Instagram">
                  <FaInstagram />
                </button>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-semibold mb-4">Contact</h4>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center gap-3">
                  <FaMapMarkerAlt className="text-gray-500" />
                  <span>Ariana, Tunisia</span>
                </li>
                <li className="flex items-center gap-3">
                  <FaPhone className="text-gray-500" />
                  <a href="tel:+21628268254" className="hover:text-white transition-colors">+216 28 268 254</a>
                </li>
                <li className="flex items-center gap-3">
                  <FaEnvelope className="text-gray-500" />
                  <a href="mailto:metaljeljeli@gmail.com" className="hover:text-white transition-colors">metaljeljeli@gmail.com</a>
                </li>
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-4">Liens rapides</h4>
              <ul className="space-y-3 text-sm">
                <li><a href="#apropos" className="text-gray-300 hover:text-white transition-colors">À propos</a></li>
                <li><a href="#services" className="text-gray-300 hover:text-white transition-colors">Nos services</a></li>
                <li><a href="#produits" className="text-gray-300 hover:text-white transition-colors">Produits</a></li>
                <li><a href="#contact" className="text-gray-300 hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
          </div>
        </div>

      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6 text-xs text-gray-400 flex flex-col md:flex-row items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} Metal JelJeli. Tous droits réservés.</span>
          <a href="#devis" className="inline-flex items-center px-4 py-2 rounded-md bg-gray-200/10 text-gray-200 hover:bg-gray-200/20">Demande de devis</a>
        </div>
      </div>
      </div>
    </footer>
  );
};

export default Footer;


